module.exports = __webpack_public_path__ + "static/media/Chen.c5494365.png";